import { createTelemetry, createTelemetryObject } from '@shared/core/analytics';

const tourTelemetry = createTelemetryObject({
  pages: {
    tourLaunched: (tourName: string, stepName: ReadonlyArray<string>, stepNumber: number) => ({
      category: 'Tour',
      pagePrefix: 'admin',
      page: `onboarding-${tourName}`,
      extraPageInfo: {
        tourName,
        stepName,
        stepNumber,
        tourAction: 'Started Tour',
      },
    }),
    tourStepShown: (tourName: string, stepName: string, stepNumber: number) => ({
      category: 'Tour',
      pagePrefix: 'admin',
      page: `onboarding-${tourName}`,
      extraPageInfo: {
        tourName,
        stepName,
        stepNumber,
        tourAction: 'Step Seen',
      },
    }),
    tourExited: (tourName: string, tourAction: 'Completed Tour' | 'Exited Tour', stepName?: string | null, stepNumber?: number) => {
      return {
        category: 'Tour',
        pagePrefix: 'admin',
        page: `onboarding-${tourName}`,
        extraPageInfo: {
          tourName,
          stepName,
          stepNumber,
          tourAction,
        },
      };
    },
  },
  actions: {
    tourStepCompactViewToggled: (showCompactView: boolean, tourName: string, stepName: string | null, stepNumber?: number) => ({
      category: 'Tour',
      pagePrefix: 'admin',
      page: `onboarding-${tourName}`,
      action: 'ButtonInteracted',
      extraInfo: {
        name: 'tourStepCompactViewToggled',
        tourName,
        stepName,
        stepNumber,
        showCompactView,
      },
    }),
  },
});

export const { TelemetryProvider: TourTelemetryProvider, useTelemetry: useTourTelemetry } = createTelemetry(tourTelemetry);
